module.exports = __webpack_public_path__ + "img/h-page4-60.cbf9f7f9.png";